import AppHelper from '@/helpers/AppHelper';
import VueI18Next from '@ringana/vue-i18next';
import { ELanguage } from '@ringana/configs';
import i18next from 'i18next';
import I18NextLocizeBackend from 'i18next-locize-backend';
import { Component } from 'vue';
import config from '../../config';
import Vue from './VueBase';
import CookieHelper from './OldCookieHelper';

let version = `production`;
if(process.env.NODE_ENV === `development`) {
  version = `latest`;
}

export class VueI18nHelper {
  public static async initVueI18NextForPage(component: Component, mountPoint: string, namespaces: string[], projectId: string = config.locize.webshopWordpress.PROJECTID): Promise<void> {
    Vue.use(VueI18Next);
    const i18nextInstance = i18next.createInstance();

    await i18nextInstance
      .use(I18NextLocizeBackend)
      .init({
        backend: {
          projectId,
          referenceLng: ELanguage.DE,
          version,
        },
        fallbackLng: ELanguage.DE,
        lng: CookieHelper.getLanguage(),
        ns: namespaces,
        supportedLngs: AppHelper.enumToArray(ELanguage).map(entry => entry.id) as string[],
      }, (err: unknown) => {
        if(err) {
          console.error(`Locize setup failed!`, err);
        }
      });

    const initializedI18Next = new VueI18Next(i18nextInstance);
    new Vue({
      i18n: initializedI18Next,
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
      render: h => h(component),
    }).$mount(mountPoint);
  }
}
